module.exports = __webpack_public_path__ + "img/php_fpm.0dc6efcc.svg";